import * as React from 'react';
import { routeNode, IRouteNodeProps } from 'react-mobx-router5';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';

// Components
import Box from '../../components/Box';
import { CircularProgress } from '../../components/Progress';

import AppBar from './AppBar';
import Content from './Content';
import Router from './Router';
import NetworksDialog from './NetworksDialog';
import MeDialog from './MeDialog';

// Component
interface IProps extends IRouteNodeProps {
  store?: IStore;
}

class App extends React.Component<IProps, {}> {
  @observable ready: boolean = false;

  @observable networksDialogState: { open: boolean } = { open: false };
  @observable meModalState: { open: boolean } = { open: false };
  @observable notificationOverlayState: { open: boolean } = { open: false };

  fetchTimer: NodeJS.Timer | number | null = null;
  @observable notificationCount: number = 0;

  componentDidMount() {
    this.initialize();
    this.props.store!.meStore.startNotificationCountPush();
  }

  async initialize() {
    this.ready = false;
    const meStore = this.props.store!.meStore;
    try {
      await meStore.meInitialize();
    } catch (err) {
      meStore.logout();
      this.props.store!.routerStore.navigate(ROUTE_PATHS.LOGIN);
    }
    this.ready = true;
  }

  openNetworkManager = () => {
    this.networksDialogState.open = true;
  };

  openMeDialog = () => {
    this.meModalState.open = true;
  };

  logout = () => {
    this.props.store!.meStore.logout();
    this.props.store!.routerStore.navigate(ROUTE_PATHS.LOGIN);
  };

  handleNetworksDialogClose = () => {
    this.networksDialogState.open = false;
  };

  handleMeDialogClose = () => {
    this.meModalState.open = false;
  };

  handleNetworkClick = () => {
    this.openNetworkManager();
  };

  handleProfileClick = () => {
    this.openMeDialog();
  };

  handleLogout = () => {
    this.logout();
  };

  componentWillUnmount() {
    this.props.store!.meStore.stopNotificationCountPush();
  }

  render() {
    const me = this.props.store!.meStore.user;
    const person = this.props.store!.networkStore.person;
    const role = person !== null ? person.role : null;
    if (this.ready === false || !me) {
      return (
        <Box mt={5} align="center">
          <CircularProgress />
        </Box>
      );
    }
    const isMobile = this.props.store!.meStore.isMobile;
    const isGoNative = this.props.store!.meStore.isGoNative;

    const currentRoute = this.props.store!.routerStore.route.name;

    return (
      <div>
        <AppBar
          currentRouteName={currentRoute}
          user={me}
          role={role}
          network={this.props.store!.networkStore.network}
          notificationCount={this.props.store!.meStore.notificationCount}
          onNetworkClick={this.handleNetworkClick}
          onAccountClick={this.handleProfileClick}
          onLogOut={this.handleLogout}
          isMobile={isMobile}
          isGoNative={isGoNative}
        />
        <Content>
          <Router openNetworkManager={this.openNetworkManager} />
        </Content>
        <NetworksDialog
          network={this.props.store!.networkStore.network}
          networks={this.props.store!.meStore.networks!}
          state={this.networksDialogState}
          onClose={this.handleNetworksDialogClose}
        />
        <MeDialog
          state={this.meModalState}
          onClose={this.handleMeDialogClose}
        />
      </div>
    );
  }
}

// Any router changes from AppNetwork to App(whatever) will not get due to the missing router
export default routeNode(ROUTE_PATHS.APP)(inject('store')(observer(App)));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/App.tsx